import { createApp } from 'vue'
import { createPinia } from 'pinia'
import createVuetify from '@gwn/ui-design-system-shared/plugins/vuetify'
import '@gwn/ui-design-system-shared/styles/Core.scss'
import './styles/in-room-call-layout.scss'
import router from './router'
import App from './App.vue'
import { requireEnv } from '@virtual-care/shared'

// Pre-flight: Log critical build-time environment to detect Safari cache issues
console.log('[InRoomEndpoint] Build configuration:', {
  apiBaseUrl: requireEnv(process.env.VUE_APP_API_BASE_URL, 'VUE_APP_API_BASE_URL'),
  socketUrl: requireEnv(process.env.VUE_APP_SOCKET_URL, 'VUE_APP_SOCKET_URL'),
  videoProvider: process.env.VUE_APP_VIDEO_PROVIDER,
  buildTimestamp: Date.now(),
})
console.log('[InRoomEndpoint] crossOriginIsolated:', self.crossOriginIsolated)
console.log('[InRoomEndpoint] SharedArrayBuffer available:', typeof SharedArrayBuffer !== 'undefined')

const app = createApp(App)

// Global error handler - suppress non-critical Zoom telemetry errors
app.config.errorHandler = (err, instance, info) => {
  const errorMessage = err?.toString() || ''
  
  // List of known non-critical Zoom telemetry domains
  const zoomTelemetryDomains = [
    'log-external-gateway.zoom.us',
    'us06das.zoom.us',
    'rwciad3.iad.zoom.us',
    'rwcsjc3.sjc.zoom.us',
    'ERR_SOCKET_NOT_CONNECTED',
    'ERR_NAME_NOT_RESOLVED'
  ]
  
  // Check if error is from Zoom telemetry (non-critical)
  const isZoomTelemetryError = zoomTelemetryDomains.some(domain => 
    errorMessage.includes(domain)
  )
  
  if (isZoomTelemetryError) {
    // Suppress - these are non-critical Zoom analytics/logging services
    console.debug('[InRoomEndpoint] Suppressed Zoom telemetry error:', errorMessage)
    return
  }
  
  // Log other errors normally
  console.error('[InRoomEndpoint] Unhandled error:', {
    error: err,
    info,
    component: instance?.$options?.name
  })
}

// Global unhandled rejection handler - suppress Zoom telemetry errors
window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason?.toString() || ''
  
  const zoomTelemetryDomains = [
    'log-external-gateway.zoom.us',
    'us06das.zoom.us',
    'rwciad3.iad.zoom.us',
    'rwcsjc3.sjc.zoom.us',
    'ajax error'
  ]
  
  const isZoomTelemetryError = zoomTelemetryDomains.some(domain => 
    reason.includes(domain)
  )
  
  if (isZoomTelemetryError) {
    console.debug('[InRoomEndpoint] Suppressed unhandled rejection (Zoom telemetry):', reason)
    event.preventDefault() // Prevent default error overlay
    return
  }
  
  console.error('[InRoomEndpoint] Unhandled rejection:', event.reason)
})

app.use(createPinia())
app.use(router)
app.use(createVuetify)

app.mount('#app')
